import React from "react";
// import { Box } from "@material-ui/core";

// import PageBanner from "../../../components/utils/PageBanner";
import QuickSightDashboard from "./QuickSightDashboard";
import { config } from "../../../config/awsExports";

const APIAnalyticsDashboard: React.FC = () => {
  const { env } = config;
  const dashboardId = env.quickSightDashboardIds.APIAnalyticsDashboard;

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      {/* Page Banner Replacement */}
      <header className="bg-white shadow">
        <div className="bg-[#F5936B] px-4 py-3">
          <h1 className="text-xl text-white "> API Analytics Dashboard</h1>
        </div>
      </header>

      {/* Main content area */}
      <main className="flex-grow p-4">
        <QuickSightDashboard id={dashboardId} />
      </main>
    </div>
  );
};

export default APIAnalyticsDashboard;
